import { actionTypes } from '../constants';

export const activeDeskIndexChanged = (value) => ({
  type: actionTypes.activeDeskIndexChanged,
  payload: value,
});
